import React, { useEffect, useState } from 'react';
import { PropTypes } from 'prop-types';
import { useIntl } from 'react-intl';
import {
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Paper,
} from '@mui/material';
import PanToolAltRoundedIcon from '@mui/icons-material/PanToolAltRounded';
import { useAtomValue } from 'jotai';
import { outcomesAtom } from '../../../../Atoms';
import {
  FullSizeColumn,
  FullSizeCenteredColumn,
} from '../../../../Components/FlexBox';
import ContentError from '../../../../Components/Error/ContentError';
import ResultForm from './ResultForm';

const CallResultBox = function CallResultBox({
  campaignId,
  answered = null,
  handleEndCall,
  isOperator = false,
  phoneNumber,
  sectionId,
  wavePeriod,
}) {
  const intl = useIntl();

  const outcomes = useAtomValue(outcomesAtom);
  const [selectedOutcome, setSelectedOutcome] = useState(null);

  const handleChangeSelectedOutcome = (newValue) => {
    setSelectedOutcome(newValue);
  };

  const resetOutcome = () => {
    setSelectedOutcome(null);
  };

  useEffect(() => {
    resetOutcome();
  }, [answered]);

  return answered === null ? (
    <FullSizeCenteredColumn>
      <ContentError
        text={intl.messages.SELECT_ANSWERED_OR_NOTANSWERED}
        icon={
          <PanToolAltRoundedIcon sx={{ color: '#acacac', fontSize: '56px' }} />
        }
      />
    </FullSizeCenteredColumn>
  ) : (
    <FullSizeColumn gap="16px" overflow="auto" flexGrow={1}>
      {!selectedOutcome ? (
        <List sx={{ padding: '16px' }}>
          {outcomes
            ?.filter(
              ({ extensionData: { answeredSection: outcomeAnswered } }) =>
                outcomeAnswered === answered
            )
            ?.map(({ id, name }) => (
              <ListItem
                key={id}
                disablePadding
                component={Paper}
                variant="outlined"
                sx={{ mb: '8px', height: '56px' }}
              >
                <ListItemButton
                  sx={{
                    height: '100%',
                    borderRadius: '18px',
                    border: (theme) =>
                      selectedOutcome === id
                        ? `2px solid ${theme.palette.primary.main}`
                        : 'unset',
                  }}
                  selected={selectedOutcome === id}
                  onClick={() => handleChangeSelectedOutcome(id)}
                >
                  <ListItemText
                    sx={{ textTransform: 'capitalize' }}
                    primary={
                      intl.messages[name?.toUpperCase()]?.toLocaleLowerCase() ||
                      name?.toLowerCase()
                    }
                  />
                </ListItemButton>
              </ListItem>
            ))}
        </List>
      ) : (
        <ResultForm
          selectedOutcomeId={selectedOutcome}
          outcomes={outcomes}
          isOperator={isOperator}
          handleResetOutcome={resetOutcome}
          onSubmit={handleEndCall}
          phoneNumber={phoneNumber}
          sectionId={sectionId}
          campaignId={campaignId}
          wavePeriod={wavePeriod}
        />
      )}
    </FullSizeColumn>
  );
};

CallResultBox.propTypes = {
  answered: PropTypes.bool,
  handleEndCall: PropTypes.func,
};

export default CallResultBox;
